import _ from 'underscore';
import moment from 'moment';

import flight_domestic_buyer_manage_order_chgList from '@/lib/data-service/flight/flight_domestic_buyer_manage_order_chgList'
import flight_domestic_buyer_manage_order_chgStates
  from '@/lib/data-service/flight/flight_domestic_buyer_manage_order_chgStates'
import flight_domestic_airlines from '@/lib/data-service/flight/flight_domestic_airlines'
// 取消订单
import order_cancel from '@/lib/data-service/flight/flight_domestic_buyer_white_order_cancel'
import scrollTop from '@/lib/common-service/scrollTop'
import changeRecord from '@/lib/data-service/flight/flight_domestic_buyer_manage_order_changeRecordCount'
import FligthTime from '../component/flightTimeBox'
import AirlineSelect from '../../components/airlineSelect'
import cancelChangePay from '@/lib/data-service/flight/buyer_dom_white_cancelChangePay'

export default {
  components: { FligthTime, AirlineSelect },
  data() {
    return {
      timeUpbox: null,
      timeUpboxHeight: null,
      searchForm: {
        pnr: ``,
        orderNo: ``,
        ticketNumber: ``,

        airCode: ``,
        psgName: ``,

        __orderTimeStart: ``,
        __orderTimeEnd: ``,

        changeStatus: `1`,
      },
      pCurrentPage: 1,
      cancelOrderNo: '',
      dialogVisible: false,
      changeRecordList: [],
      pageResult: {
        currentPage: 1,
        pageSize: 10,
        pageData: [],
        totalCount: 0,
      },

      data_flight_domestic_airlines: {
        pageResult: {
          pageData: [],
        }
      },

      data_flight_domestic_buyer_manage_order_chgStates: {
        pageResult: {
          pageData: [],
        }
      },
      NavItemActive: 0,
      loading: true,
    };
  },
  computed: {
    orderTimeStart: {
      get() {
        const __this = this;
        const flag = moment(__this.searchForm.__orderTimeStart).isValid();
        let s = ``;
        if (flag) {
          const d = moment(__this.searchForm.__orderTimeStart);
          s = d.format(`YYYY/MM/DD`);
        }
        return s;
      }
    },
    orderTimeEnd: {
      get() {
        const __this = this;
        const flag = moment(__this.searchForm.__orderTimeEnd).isValid();
        let s = ``;
        if (flag) {
          const d = moment(__this.searchForm.__orderTimeEnd);
          s = d.format(`YYYY/MM/DD`);
        }
        return s;
      }
    },
  },
  methods: {

    async __data_bind_list(pParameter) {
      const __this = this;
      if (!pParameter) pParameter = {};
      const currentPage = pParameter.currentPage || __this.pageResult.currentPage;
      const pageSize = pParameter.pageSize || __this.pageResult.pageSize;

      const pnr = __this.searchForm.pnr;
      const orderNo = __this.searchForm.orderNo;
      const ticketNumber = __this.searchForm.ticketNumber;
      const airCode = __this.searchForm.airCode;
      const psgName = __this.searchForm.psgName;
      const changeStatus = __this.searchForm.changeStatus;
      let _fromData = this.searchForm
      const orderTimeStart = __this.orderTimeStart;
      const orderTimeEnd = __this.orderTimeEnd;
      let data = {
        currentPage: currentPage,
        pageSize: pageSize,
        pnr: pnr,
        orderNo: orderNo,
        ticketNumber: ticketNumber,
        airCode: airCode,
        psgName: psgName,
        changeStatus: changeStatus,
        orderTimeStart: orderTimeStart,
        orderTimeEnd: orderTimeEnd,
        flightNo: _fromData.flightNo,
        contactTel: _fromData.contactTel,
        psgCardNo: _fromData.psgCardNo
      }
      __this.loading = true;
      flight_domestic_buyer_manage_order_chgList(data).then(res => {
        __this.pageResult.pageData = res.pageResult.pageData || [];
        __this.pageResult.totalCount = res.pageResult.totalCount
        __this.loading = false;
        this._changeRecord(data)
        scrollTop(500)
      }).catch(error => {
        __this.pageResult.pageData = []
        __this.pageResult.totalCount = 0
        __this.loading = false;
      })

    },
    cancelFilling(val) {
      this.$confirm('确定取消改签吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        cancelChangePay({ changeNo: val.changeOrderNo, orderNo: val.orderNo }).then(res => {
          console.log(res)
          this.$message({ type: 'success', message: "取消改签成功！" })
        })
      }).catch(() => {
      });

    },
    __el_pagination_current_change_event_handler(pCurrentPage) {
      const __this = this;
      this.pCurrentPage = pCurrentPage
      __this.__data_bind_list({
        currentPage: pCurrentPage,
      });
    },
    _changeRecord(data) {
      changeRecord(data).then(res => {
        this.changeRecordList = res.records
      })
    },
    pay(val) {
      console.log(val)
      let psgNoList = val.passengerList.map(item => {
        return item.psgNo
      })
      this.$router.push({ name: 'air-chang-payment', query: { ordersNo: val.changeOrderNo, psgNoList, pay: '12', } })
    },
    setOrdersNo(ordersNo, toString, psgList) {
      // if (type == 'pay') {
      //   return this.$router.push({ name: toString, query: { ordersNo: ordersNo, pay: '12' } })
      // }
      let psgType, psgNo

      if (psgList) {
        let psg = psgList.map(item => {
          return item.psgType
        })
        psgNo = psgList.map(item => {
          return item.psgNo
        })
        if (psg.indexOf(1) != -1) {
          psgType = 1
        } else {
          psgType = 2
        }
      }
      this.$router.push({
        name: toString,
        query: {
          ordersNo,
          psgType,
          psgNo: JSON.stringify(psgNo),
          orderType: 'change'
        }
      })
    },
    offHeight(e) {
      this.timeUpboxHeight = e.target.offsetParent.offsetHeight
      // this.timeUpboxHeight = e.fromElement.localName == 'td' ? e.fromElement.offsetHeight : 0
    },
    cancel(ordersNo) {
      let parame = {
        orderNo: ordersNo,
        remark: ''
      }
      order_cancel(parame).then(res => {
        res.isSuccess ?
          this.$message({ type: "warning", message: "操作成功！" }) : ''
        this.__data_bind_list({ currentPage: this.pCurrentPage })
      })
    },

    __el_pagination_size_change_event_handler(pPageSize) {
      const __this = this;
      __this.pageResult.pageSize = pPageSize
      __this.__data_bind_list();
    },

    __btn_search_click() {
      const __this = this;
      __this.__data_bind_list({ currentPage: 1 });
    },

    __btn_reset_click() {
      const __this = this;

      _.each(__this.searchForm, function (property_value, property_name) {
        __this.searchForm[property_name] = ``;
      });
      __this.searchForm.changeStatus = `1`;

      __this.__data_bind_list();
    },

    __btn_tab_click(pItem, pIndex) {
      const __this = this;
      __this.searchForm.changeStatus = pItem.status;
      __this.NavItemActive = pIndex;
      this.pageResult.currentPage = 1
      __this.__btn_search_click();
    },

  },
  watch: {
    '$route.query.ordersNo': function (newId) {
      this.__data_bind_list()
    }
  },
  async mounted() {
    const __this = this;

    const data_flight_domestic_airlines = await flight_domestic_airlines();
    __this.data_flight_domestic_airlines = data_flight_domestic_airlines;

    // const data_flight_domestic_buyer_manage_order_chgStates = await flight_domestic_buyer_manage_order_chgStates();
    // __this.data_flight_domestic_buyer_manage_order_chgStates = data_flight_domestic_buyer_manage_order_chgStates;

    __this.__data_bind_list();
  },
}
